import { render, staticRenderFns } from "./ModalTEF.vue?vue&type=template&id=032ca088&"
import script from "./ModalTEF.vue?vue&type=script&lang=js&"
export * from "./ModalTEF.vue?vue&type=script&lang=js&"
import style0 from "./ModalTEF.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports